import { emptyObj } from '@beef/utils';
import { getContentData } from "../selectors";
var getUserRegion = function getUserRegion(state) {
  return getContentData(state).userRegion || emptyObj;
};
export var getRegionIn = function getRegionIn(state) {
  return getUserRegion(state).titlePreposition;
};
export var getRegion = function getRegion(state) {
  return getUserRegion(state).title;
};
export var getIsFTTB = function getIsFTTB(state) {
  return getUserRegion(state).isFTTB;
};